import React from 'react';
import SEOHelmet from '../components/SEOHelmet';

const AboutPage = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "name": "About Ceremonzy",
    "description": "Learn about Ceremonzy, India's trusted wedding vendor platform founded by Cleon Jackson Lopes. Our mission is to connect couples with premium ceremony vendors.",
    "url": "https://ceremonzy.com/about",
    "mainEntity": {
      "@type": "Organization",
      "name": "Ceremonzy",
      "description": "Premium wedding vendor platform",
      "founder": {
        "@type": "Person",
        "name": "Cleon Jackson Lopes",
        "jobTitle": "Founder",
        "description": "B.Tech Computer Engineering student with a vision for transforming businesses through technology"
      }
    }
  };

  return (
    <>
      <SEOHelmet
        title="About Ceremonzy - India's Trusted Wedding Vendor Platform | Our Story"
        description="Discover the story behind Ceremonzy, India's premier wedding vendor platform. Founded by Cleon Jackson Lopes to revolutionize ceremony planning and connect couples with trusted vendors."
        keywords="About Ceremonzy, wedding vendor platform, Cleon Jackson Lopes, wedding planning India, ceremony vendors, wedding marketplace story"
        url="/about"
        structuredData={structuredData}
      />
      <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-pink-600 to-purple-700 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              About Ceremonzy
            </h1>
            <p className="text-xl md:text-2xl opacity-90 max-w-3xl mx-auto">
              Vasai's most trusted ceremony vendor marketplace, connecting people with verified professionals for their perfect day
            </p>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                Our Mission
              </h2>
              <p className="text-lg text-gray-600 mb-6">
                To revolutionize ceremony planning in Vasai by creating a seamless, transparent, and trust-worthy platform that connects people with the best ceremony vendors in the region.
              </p>
              <p className="text-lg text-gray-600">
                We believe that everyone deserves access to quality vendors and services, regardless of their location or budget. Our mission is to make ceremony planning stress-free, enjoyable, and memorable.
              </p>
            </div>
            <div className="bg-white rounded-xl shadow-lg p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Vision</h3>
              <p className="text-lg text-gray-600">
                To become the most trusted platform for all ceremony and occasion planning, making it easy for people to find and connect with the best local vendors for their special moments.
              </p>
            </div>
          </div>
        </div>
      </section>


      {/* Developer Section */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Built with ❤️ by
            </h2>
          </div>

          <div className="bg-gradient-to-br from-pink-50 to-purple-50 rounded-2xl p-8">
            <div className="flex flex-col lg:flex-row items-center lg:items-start space-y-8 lg:space-y-0 lg:space-x-12">
              <div className="flex-shrink-0">
                <img
                  src="https://res.cloudinary.com/dgban38oz/image/upload/v1759924485/My_image_ifvt7j.jpg"
                  alt="Cleon Jackson Lopes"
                  className="w-48 h-48 rounded-full object-cover shadow-lg border-4 border-white"
                />
              </div>
              
              <div className="flex-1 text-center lg:text-left">
                <h3 className="text-4xl font-bold text-gray-900 mb-2">Cleon Jackson Lopes</h3>
                <p className="text-2xl text-pink-600 font-bold mb-6">Founder</p>
                
                <div className="space-y-4 text-gray-700 text-lg leading-relaxed">
                  <p>
                    A final year B.Tech Computer Engineering student with a vision and passion for problem-solving and for using technology to transform and grow businesses.
                  </p>
                  <p>
                    Ceremonzy is a vendor marketplace offering a seamless experience for planning special occasions. This project reflects my vision of using technology to simplify processes, empower businesses, and connect people with trusted ceremony vendors.
                  </p>
                </div>
                
                <div className="mt-8 p-4 bg-white rounded-lg shadow-sm">
                  <div className="flex items-center justify-center lg:justify-start">
                    <svg className="w-6 h-6 text-pink-600 mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                      <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                    </svg>
                    <span className="text-lg font-medium text-gray-800">Contact: lopescleon07@gmail.com</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      </div>
    </>
  );
};

export default AboutPage;